<template>
	<div>
		<div class="col-md-4 pt-3 centre_sm_none" :class="{'d-sm-block':!specail&&(viewToggle||!clickToggle),'d-none':!specail&&(viewToggle||!clickToggle)}">
			<div class="centre_content consult_left">
				<div id="consult_left_content" class="pl-3">
					<i class="fa fa-mortar-board fa-lg mr-2"></i>Consulting Service
                    <span class="myBtn" @click='goback()'>Back</span>
				</div>
				<div class="row nano one_title_nano m-0">
					<div class="nano-content" id="home_left_list">
						<ul class="list-unstyled consulList">
							<li v-for='(value,key) in particulars' class="media pb-3 pt-3 pl-4 pr-3 border-bottom" style="position: relative;">
								<router-link :to="{name:'consultorganization',params :{contentid:value.id}}" class="w-100" style="display: contents;">

									<img v-if="value.thumb != ''" :src="value.thumb" class="mr-3 img-thumbnail" style="max-width: 30%;">

									<div class="media-body">
										<h5 class="f16"><a href="javascript:" class="f15 font-weight-bold myActive" target="_blank">{{value.title}}</a></h5>
                                        <div  class="media-foot f13 mt-3 mb-3 font-weight-light text-muted">
                                            <span>{{ value.description}}</span>
                                        </div>
                                        <div class="media-foot mt-1 font-weight-light f12">
											<span class="p-1">
												<img @click.prevent="Torouter(value.space.alias)"  :src="value.space.photo" class="rounded-circle" style="width: 30px;height: 30px;">
											</span>
											<span class="p-1" @click.prevent="Torouter(value.space.alias)">{{value.space.name}}</span>
											<!--<span class="organization p-1" @click.prevent="gotoPage(value.space.typeid)">{{value.space.type}}</span>-->
											<span class="p-1">{{value.published}}</span>
										</div>
									</div>
								</router-link>
							</li>
							<p class="text-center p-2" v-if="loadShow"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>
							<p class="text-center p-2" v-if="endShow">loading...</p>
						</ul>
					</div>
				</div>

			</div>
		</div>
		<div class="col-md-8 pl-0 mt-3 centre_sm_none" :class="{'d-sm-block':!specail&&(viewToggle||clickToggle),'d-none':!specail&&(viewToggle||clickToggle)}">
            <consultArticle></consultArticle>
		</div>
	</div>
</template>
<script>
    import consultArticle from './ArticleDetails/Article.vue'
	export default({
		name: 'consultorganization',
		data: function() {
			return {
				particulars: [],
				page: 1,
				total_page: 1,
                page_size: 15,
                specail:false, //特殊处理 小于544px
                viewToggle:true,
                clickToggle:true,
                loadShow:false,
                endShow:false
			}
		},
		created: function() {
			var self = this;
            if(this.IsPC()&&(document.body.clientWidth<=700)){
                this.specail=true
            }else{
                this.specail=false
            }
			this.viewToggle=this.IsPC();
            this.$axios.post('/api/pc/getcontent', {
                    page: this.page,
                    pagesize: this.page_size
                }).then(data => {
                    var particular = data.data.data;
                    self.particulars = particular;
                    self.total_pages = data.data.maxpage;
                })

		},
		mounted() {
			document.getElementById('home_left_list').addEventListener('scroll', this.Scrolles);
			this.load();
		},
		methods: {
            goback(){
                if(this.clickToggle){
                    this.$router.push({name:'consult_particulars_organization',params :{id:"10",type:1}})
                }else{
                    this.clickToggle=true;
                }
            },
            // 详情跳转
            Torouter(item) {
                this.$router.push({name:'consultdetails',params :{name:item, contentid:0}})
            },
            gotoPage(num) {

                this.$router.push({name:'consult_particulars_organization',params :{id:"10",type:num}})
            },
            clickToggles(){
                this.clickToggle=false;
            },
			Scrolles() {
				var top = document.getElementById('home_left_list').scrollTop; // 滚动条到上面的距离
				var client = document.getElementById('home_left_list').clientHeight; // 可视区域的高度
				var all = document.getElementById('home_left_list').scrollHeight; // 总高度

				if((all - 20) < (top + client) && !this.loadShow) {
					this.page++;
					if(this.page > this.total_page) {
                        this.endShow = true;
						return;
					}
					this.loadShow = true;
                    var self = this;
					this.$axios.post('/api/pc/getcontent', {
						page: this.page,
                        pagesize:this.page_size
					}).then(data => {
						var particulares = data.data.data;
						//						self.particulars = particular;
						JSON.stringify(particulares);
						var new_particular = self.particulars.concat(particulares);
						self.particulars = new_particular;
						self.loadShow = false;
					})
				}
			},
		},
        computed: {
            isFollow () {
                return this.$store.state.screenWidth;
            }
        },
		watch: {
            isFollow (val) {
                if (!this.timer) {
                    //this.screenWidths = val;
                    this.timer = true;
                    let that = this;
                    setTimeout(function () {
                        if(that.IsPC()&&(val<=700)){
                            that.specail=true
                        }else{
                            that.specail=false
                        }
                        that.timer = false
                    }, 300)
                }

            }
		},
        components: {
            consultArticle
        }

	})
</script>
<style scoped>
    .myBtn{
        width:60px;
        height:30px;
        display:block;
        position:absolute;
        top:20px;
        right:20px;
        font-size:12px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(133,144,166,1);
        line-height:30px;
        text-align:center;
        background:rgba(242,243,244,1);
        border-radius:20px;
    }
    .myBtn:hover{
        cursor:pointer;
    }
</style>
